import * as actionTypes from '../actionTypes/interviewReview';

export default {
  setJobDesData: (params) => ({
    type: actionTypes.SET_JOB_DES_DATA,
    payload: params,
  }),
  resetInterviewReviewData: () => ({
    type: actionTypes.RESET_INTERVIEW_REVIEW_DATA,
  }),
  setOverallReviewData: (params) => ({
    type: actionTypes.SET_OVERALL_REVIEW_DATA,
    payload: params,
  }),
  setAllQnAData: (params) => ({
    type: actionTypes.SET_ALL_QNA_DATA,
    payload: params,
  }),
  setInterviewReviewData: (params) => ({
    type: actionTypes.SET_INTERVIEW_REVIEW_DATA,
    payload: params,
  }),
  setAns: (params) => ({
    type: actionTypes.SET_ANS,
    payload: params,
  }),
};
